import { createContext, useCallback, useEffect, useRef, useState } from 'react';
import { useLoginInfo } from '../../../../../../Core/Hooks/useLoginInfo';
import { useWindowSize } from '../../../../../../Core/Hooks/useWindowSize';
import { useToast } from '../../../../../../Core/Hooks/useToast';
import moment from 'moment';
import { AppStorage } from '../../../../../../Core/Basic/storage-service';
import { getTitleData, getVehicleById } from '../../../../../../Core/Services/InternalUser/ControllerService/vehicleService';
import {
    deleteImageByID,
    getChecksAddTabByID,
    getChecksEditByID,
    getImageByID,
    getTyreCheckData,
    postChecksData,
    PostImage
} from '../../../../../../Core/Services/InternalUser/Vehicle/vehicleTabChecks';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { usePortalSettings } from '../../../../../../Core/Hooks/usePortalSettings';

export const InspectionCheCkContaxt = createContext();

export const InspectionCheckProvider = (props) => {
    const portalSettings = usePortalSettings();
    const { displayName } = useLoginInfo();
    const [btnLoader, setBtnLoader] = useState(false);
    const localFileInputRef = useRef(null);
    const apiFileInputRef = useRef(null);
    const [imgLoader, setImgLoader] = useState(false);
    const AUTO_SAVE_INTERVAL_MS = 60000;
    const autoSaveTimerRef = useRef(null); // pending countdown (null = none running)
    const autoSaveRef = useRef(null); // re-bound every render -> always saves the latest form state
    const activitySinceLastSaveRef = useRef(false); // true = there are unsaved changes
    const inFlightSaveRef = useRef(null); // promise of the auto-save currently in progress
    const pendingSaveRef = useRef(false); // countdown expired while a save was in progress
    // Inspection id returned by the first save. Kept in a ref (not just state) so the very next
    // request uses it immediately, before React re-renders — otherwise it could send null again
    // and create a duplicate inspection.
    const savedInspectionIdRef = useRef(props.checkID || null);

    // Fixed-window auto-save (NOT a debounce): the FIRST change starts a 60s countdown and
    // further changes never restart it. When it expires, the latest form state is saved,
    // including every change made up to that moment. The next change after that starts a new
    // countdown; if the user stays idle, nothing more is sent.
    const markActivity = () => {
        activitySinceLastSaveRef.current = true;
        if (autoSaveTimerRef.current) return; // countdown already running — do not reset it
        autoSaveTimerRef.current = setTimeout(() => {
            autoSaveTimerRef.current = null;
            // Only save if there are still unsaved changes (a manual save may have covered them).
            if (activitySinceLastSaveRef.current && autoSaveRef.current) {
                autoSaveRef.current();
            }
        }, AUTO_SAVE_INTERVAL_MS);
    };

    const [state, setState] = useState({
        checksList: [],
        buttonList: [],
        passVal: false,
        imageUpload: [],
        date: moment().format('YYYY-MM-DD'),
        inspectionSheetAxlesVM: [],
        VehicleDailyCheckResultsVM: [],
        vehicleInspectionID: props.checkID || null,
        vehicleInspectionScheduleID: props.sheduleID,
        vehicleDailyCheckCheckerName: displayName,
        vehicleInspectionStatusID: null,
        vehicleInspectionDateInspected: moment().format('YYYY-MM-DD'),
        vehicleInspectionInspectorSignOffDate: null,
        vehicleInspectionResult: null,
        vehicleInspectionSignedOffComment: null,
        vehicleInspectionSignedOffName: null,
        vehicleInspectionSignedOffSignature: null,
        vehicleInspectionSignedOffDate: null,
        vehicleInspectionSignedOffIPAddress: null,
        loader: true,
        signAvailable: AppStorage.getSignature() === 'absent' ? false : true,
        windowWidth: window.innerWidth,
        axleErrors: {},
        showTost: false,
        showConfirmMessage: false,
        vehicleNoOfAxles: null,
        selectedRowInspectionID: null,
        openDefectInspection: false,
        inspectionName: '',
        isDisabled: false,
        getImageList: [],
        inspectionSheetBrakeLiningsVM: [],
        showSubmit: false,
        inpsectionNotes: [],
        listOptionsVM: [],
        showImageModal: false,
        showImageModalAPI: false,
        postimageUpload: []
    });

    const history = useHistory();
    let checkhaveAccess = AppStorage.getAllowAcces();

    const [flags, setFlags] = useState({});
    const [widths, heights] = useWindowSize();
    const { showToastSuccess, showToastError } = useToast();

    const handleInpectionRow = (id, name) => {
        setState((st) => ({ ...st, selectedRowInspectionID: id, openDefectInspection: true, inspectionName: name }));
    };

    const closeInspection = () => {
        setState((st) => ({ ...st, selectedRowInspectionID: null, openDefectInspection: false, inspectionName: '' }));
    };

    const [isModal, setIsModal] = useState({ actionTaken: false, selectedCheck: null, showConfirm: false });

    const handleInput = (e) => {
        markActivity();
        const { name, value } = e.target;
        if (name === 'vehicleInspectionBrakeTestTypeID') {
            setState((state) => ({ ...state, [name]: +value }));
        } else if (name === 'date') {
            const today = moment().format('YYYY-MM-DD');
            if (value && moment(value).isAfter(today, 'day')) {
                setState((state) => ({ ...state, [name]: today }));
            } else {
                setState((state) => ({ ...state, [name]: value }));
            }
        } else {
            setState((state) => ({ ...state, [name]: value }));
        }
    };

    useEffect(() => {
        async function FetchData() {
            try {
                if (props.sheduleVechicleID) {
                    let vehicleInformation = await getTitleData(props.sheduleVechicleID);

                    if (vehicleInformation.success) {
                        setState((st) => ({
                            ...st,
                            vehicleInfo: vehicleInformation.data.details[0]?.vehicleDescription,
                            vehicleNextCalibrationDate: vehicleInformation.data.details[0]?.vehicleNextCalibrationDate,
                            vehicleNextTachoCalibrationDate: vehicleInformation.data.details[0]?.vehicleNextTachoCalibrationDate,
                            vehicleNextLolerTestDate: vehicleInformation.data.details[0]?.vehicleNextLolerTestDate,
                            vehicleNoOfAxles: vehicleInformation?.data?.details[0]?.vehicleNoOfAxles,
                            customerCompanyName: vehicleInformation?.data?.details[0]?.customerCompanyName,
                            jobID: vehicleInformation?.data?.details[0]?.jobID
                        }));
                    }
                    let res2 = await getVehicleById(props.sheduleVechicleID);
                    if (res2.success) {
                        const data = res2.data.details[0];
                        // console.log(data, 'data');
                        setState((st) => ({
                            ...st,
                            regNumber: data.vehicleRegNumber,
                            modelID: data.vehicleModel,
                            makeID: data.vehicleMake,
                            customerID: data.vehicleCustomerID,
                            depotID: data.vehicleDepotID,
                            vehicleID: data.vehicleID
                        }));
                    }

                    // pullInpectionChecks();
                }
            } catch (error) {
                console.error(error);
            }
        }

        return FetchData();
    }, [props.sheduleVechicleID]);

    // console.log(state, 'vehicleDepotID');

    //Add Inspection
    let pullInpectionChecks = async () => {
        let res = await getChecksAddTabByID(props.sheduleVechicleID, props.displayCheck, props.scheduleEventID, props.sheduleID);

        if (res.success) {
            let tempArray = [];
            res?.data?.inspectionSheetSectionsVM?.map((q) => {
                q.inspectionSheetChecksVM?.map((r) => {
                    r.inspectionSheetCheckResultCheckID = r.inspectionSheetCheckID;
                    r.inspectionSheetCheckResultOptionCode = null;
                    r.inspectionSheetCheckResultNotes = null;
                    r.inspectionSheetCheckResultIMReference = null;
                    r.inspectionSheetCheckResultDefectID = null;
                    tempArray.push(r);
                });
            });
            let inspectionSheetBrakeLiningsVM = res?.data?.inspectionSheetBrakeLiningsVM;
            let listOptionsVM = res?.data?.listOptionsVM || [];
            const axles = [1, 2, 3, 4].map((num) => ({ axleNumber: num }));
            let flagData = res?.data?.inspectionSheetTypesVM[0] || {};

            setFlags((prevFlag) => ({
                ...prevFlag,
                displayBrakePerformance: flagData.displayBrakePerformance,
                displayBrakeTest: flagData.displayBrakeTest,
                displayMileage: flagData.displayMileage,
                displayRoadTest: flagData.displayRoadTest,
                displayTyres: flagData.displayTyres,
                endEventLabel: flagData.endEventLabel,
                startEventLabel: flagData.startEventLabel,
                displayStartEvent: flagData.displayStartEvent,
                displayCustomerDeclaration: flagData.displayCustomerDeclaration,
                scheduleEventName: flagData.scheduleEventName,
                startVehicleInspectionID: flagData.startVehicleInspectionID
            }));

            setState((st) => ({
                ...st,
                checksList: res?.data?.inspectionSheetSectionsVM || [],
                buttonList: res.data?.inspectionSheetCheckOptionsVM || [],
                VehicleDailyCheckResultsVM: tempArray || [],
                loader: false,
                inspectionSheetBrakeLiningsVM: inspectionSheetBrakeLiningsVM || [],
                inspectionSheetAxlesVM: axles,
                inpsectionNotes: res.data?.notesVM,
                listOptionsVM: listOptionsVM
            }));
        }
    };

    const actionTakenHandle = (check) => {
        setIsModal((st) => ({
            ...st,
            actionTaken: true,
            selectedCheck: check
        }));
    };

    const closeActionTakenhandle = (res) => {
        //     let checkList = [...state.vehicleDailyChecksResult].filter((k) => k.resultStatus === 'Unreviewed');

        //     let objIndex = checkList.findIndex((x) => x.inspectionSheetCheckResultID === isModal.selectedCheck.inspectionSheetCheckResultID);
        //     if (objIndex !== -1) {
        //         checkList.splice(objIndex, 1);
        //     }

        setIsModal((st) => ({
            ...st,
            actionTaken: false,
            showConfirm: false
        }));
        res && props.onClose(true);
    };

    //Edit Inspection
    let pullEditInpectionChecks = async () => {
        let inspectionID = props.checkID || state.vehicleInspectionID;
        if (inspectionID) {
            let res = await getChecksEditByID(inspectionID, props.displayCheck);

            if (res.success) {
                res.data.vehicleDailyChecks.map((item) => {
                    if (item.vehicleInspectionSignedOffSignature) {
                        setState((st) => ({
                            ...st,
                            showbtn: false
                        }));
                    }
                    setState((st) => ({
                        ...st,
                        vehicleID: item.vehicleID,
                        vehicleRegNumber: item.vehicleRegNumber,
                        date: moment(item.vehicleInspectionDateInspected).format('YYYY-MM-DD'),
                        makeID: item.vehicleMake,
                        modelID: item.vehicleModel,
                        imgtechniciansign: item.vehicleInspectionInspectorSignature,
                        techniciansign: item.vehicleInspectionInspectorSignature,
                        vehicleInspectionScheduleID: item.vehicleInspectionScheduleID,
                        vehicleInspectionStatusID: item.vehicleInspectionStatusID,
                        vehicleInspectionDateInspected: moment(item.vehicleInspectionDateInspected).format('YYYY-MM-DD hh:mm'),
                        vehicleInspectionInspectorSignOffDate: item.vehicleInspectionInspectorSignOffDate,
                        vehicleInspectionResult: item.vehicleInspectionResult,
                        vehicleDailyCheckMileage: item.vehicleInspectionMileage,
                        vehicleInspectionSlippageReasonID: item.vehicleInspectionSlippageReasonID,
                        vehicleDailyCheckCheckerName: item.vehicleInspectionInspectorName,
                        vehicleInspectionInspectionComment: item.vehicleInspectionInspectionComment,
                        vehicleInspectionSignedOffName: item.vehicleInspectionSignedOffName,
                        vehicleInspectionSignedOffSignature: item.vehicleInspectionSignedOffSignature,
                        signOffsignature: item.vehicleInspectionSignedOffSignature,
                        hideSignOff: item.vehicleInspectionSignedOffSignature,
                        vehicleInspectionSignedOffDate: item.vehicleInspectionSignedOffDate,
                        vehicleInspectionSignedOffIPAddress: item.vehicleInspectionSignedOffIPAddress,
                        vehicleInspectionID: item.vehicleInspectionID,
                        vehicleInspectionSignedOffComment: item.vehicleInspectionSignedOffComment,

                        vehicleInspectionBrakeTestTypeID: item.vehicleInspectionBrakeTestTypeID, // 2,
                        vehicleInspectionBrakeTestNumber: item.vehicleInspectionBrakeTestNumber, // "12345",
                        vehicleInspectionRoadCondition: item.vehicleInspectionRoadCondition, // "Test Road Conditions",
                        vehicleInspectionServiceBrakePerformance: item.vehicleInspectionServiceBrakePerformance, // 71,
                        vehicleInspectionSecondaryBrakePerformance: item.vehicleInspectionSecondaryBrakePerformance, // 72,
                        vehicleInspectionParkingBrakePerformance: item.vehicleInspectionParkingBrakePerformance, // 73,
                        vehicleInspectionBrakeTestPhoto: item.vehicleInspectionBrakeTestPhoto
                    }));
                });

                let flagData = res.data.inspectionSheetTypesVM[0];

                let tempArray = res.data.vehicleDailyChecksResult?.map((q) => ({
                    ...q,
                    inspectionSheetCheckResultCheckID: q.inspectionSheetCheckID,
                    inspectionSheetCheckResultOptionCode: q.inspectionSheetCheckResultOptionCode || null,
                    inspectionSheetCheckResultNotes: q.inspectionSheetCheckResultNotes || null,
                    inspectionSheetCheckResultIMReference: q.inspectionSheetCheckResultIMReference || null,
                    inspectionSheetCheckResultDefectID: q.inspectionSheetCheckResultDefectID || null
                }));

                let inspectionSheetBrakeLiningsVM = res?.data?.inspectionSheetBrakeLiningsVM;
                let listOptionsVM = res?.data?.listOptionsVM || [];

                const axles = [1, 2, 3, 4].map((num) => res?.data?.tyreAxles.find((x) => x.axleNumber === num) || { axleNumber: num });

                setFlags((prevFlag) => ({
                    ...prevFlag,
                    displayBrakePerformance: flagData.displayBrakePerformance,
                    displayBrakeTest: flagData.displayBrakeTest,
                    displayMileage: flagData.displayMileage,
                    displayRoadTest: flagData.displayRoadTest,
                    displayTyres: flagData.displayTyres,
                    endEventLabel: flagData.endEventLabel,
                    startEventLabel: flagData.startEventLabel,
                    displayStartEvent: flagData.displayStartEvent,
                    displayCustomerDeclaration: flagData.displayCustomerDeclaration,
                    scheduleEventName: flagData.scheduleEventName
                }));

                setState((st) => ({
                    ...st,
                    inspectionSheetAxlesVM: axles,
                    loader: false,
                    buttonList: res.data?.vehicleDailyCheckOptions,
                    VehicleDailyCheckResultsVM: tempArray || [],
                    inspectionSheetBrakeLiningsVM: inspectionSheetBrakeLiningsVM || [],
                    inpsectionNotes: res.data?.notes || [],
                    listOptionsVM: listOptionsVM
                }));
            }
        }
    };

    useEffect(() => {
        if (props.checkID) {
            pullEditInpectionChecks();
        } else {
            pullInpectionChecks();
        }
    }, [props.sheduleVechicleID, props.displayCheck, props.scheduleEventID, props.sheduleID, props.checkID]);

    useEffect(() => {
        if (props.checkID) {
            if (state.VehicleDailyCheckResultsVM.length > 0) {
                let checksList = state.VehicleDailyCheckResultsVM.map((m, i) => {
                    return {
                        inspectionSheetSectionDescription: m.inspectionSheetSectionDescription,
                        inspectionSheetChecksVM: state.VehicleDailyCheckResultsVM.filter(
                            (p) => m.inspectionSheetSectionDescription === p.inspectionSheetSectionDescription
                        ).map((list) => ({
                            ...list,
                            inspectionSheetCheckCanHideDefectDescription: list.inspectionSheetCheckCanHideDefectDescription,
                            inspectionSheetCheckCanHidePhotoUpload: list.inspectionSheetCheckCanHidePhotoUpload,
                            inspectionSheetCheckDescription: list.inspectionSheetCheckDescription,
                            inspectionSheetCheckFreeTextField: list.inspectionSheetCheckFreeTextField,
                            inspectionSheetCheckID: list.inspectionSheetCheckID,
                            inspectionSheetCheckResultOptionCode: list.inspectionSheetCheckResultOptionCode || '',
                            previousNotes: '',
                            previousResultCode: '',
                            previousVehicleInspectionID: 0,
                            startFreeText: list.startFreeText,
                            startInspectionSheetCheckResultID: list.startInspectionSheetCheckResultID,
                            startNotes: list.startNotes,
                            startPhotosUploaded: list.startPhotosUploaded,
                            startResultCode: list.startResultCode,
                            startVehicleInspectionID: list.startVehicleInspectionID,
                            inspectionSheetCheckResultNotes: list.inspectionSheetCheckResultNotes
                        }))
                    };
                });

                let vehicleChecksList = Object.values(
                    checksList.reduce((acc, cur) => Object.assign(acc, { [cur.inspectionSheetSectionDescription]: cur }), {})
                );
                setState((st) => ({ ...st, checksList: vehicleChecksList }));
            }
        }
    }, [state.VehicleDailyCheckResultsVM, props.checkID]);

    let getPreviousTyreData = async () => {
        let res = await getTyreCheckData(props.sheduleVechicleID);
        if (res.success) {
            if (res.data.previousAxle.length > 0) {
                const inspectionSheetAxlesVM =
                    res.data?.previousAxle?.map((item) => {
                        const { nsBeforeBrakeTemperatureAxle, nsBrakeTemperatureAxle, osBeforeBrakeTemperatureAxle, osBrakeTemperatureAxle, ...rest } = item;
                        return rest;
                    }) || [];

                const inspectionSheetAxlesVMs = inspectionSheetAxlesVM.map((curr) => {
                    const prev = state.inspectionSheetAxlesVM.find((p) => p.axleNumber === curr.axleNumber);
                    return {
                        ...prev,
                        ...curr
                    };
                });
                setState((st) => ({
                    ...st,
                    inspectionSheetAxlesVM: inspectionSheetAxlesVMs
                }));
                markActivity();
                showToastSuccess('Data Added Successfully');
            } else {
                showToastError('No Record Found');
            }
        } else {
            showToastError(res.data.message);
        }
    };

    //Signature

    const signCanvas = useRef({});

    const clear = () => {
        if (state.imgtechniciansign) {
            setState((st) => ({
                ...st,
                imgtechniciansign: false,
                techniciansign: null
            }));
        } else {
            setState((st) => ({ ...st, techniciansign: null }));
            signCanvas.current.clear();
        }
    };

    const GetTechnicianSign = () => {
        setState((st) => {
            const nst = {
                ...st,
                techniciansign: signCanvas.current.toDataURL()
            };
            return nst;
        });
    };

    const useDefaultSig = () => {
        setState((st) => ({ ...st, imgtechniciansign: true, techniciansign: AppStorage.getSignature() }));
    };

    // console.log(state.techniciansign, 'techniciansign');

    useEffect(() => {
        const handleResize = () => {
            if (
                signCanvas.current &&
                typeof signCanvas.current.fromDataURL === 'function' &&
                state.techniciansign &&
                !state.imgtechniciansign // only restore if not using default
            ) {
                signCanvas.current.fromDataURL(state.techniciansign);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [state.techniciansign, state.imgtechniciansign]);

    //Handle Inspections

    const changeState = useCallback(
        (buttonVal, checkId) => {
            markActivity();
            // console.log(buttonVal, checkId);
            let changedArray = [...state.VehicleDailyCheckResultsVM];
            let objIndex = state.VehicleDailyCheckResultsVM.findIndex((x) => x.inspectionSheetCheckID === checkId);
            if (objIndex > -1) {
                changedArray[objIndex].inspectionSheetCheckResultOptionCode = buttonVal;
                setState((st) => ({ ...st, VehicleDailyCheckResultsVM: changedArray }));
            }
        },
        [state.VehicleDailyCheckResultsVM]
    );

    const changeNotesState = useCallback(
        (id, des) => (e) => {
            markActivity();
            let changedArray = [...state.VehicleDailyCheckResultsVM];
            let objIndex = state.VehicleDailyCheckResultsVM.findIndex((x) => x.inspectionSheetCheckID === id);
            changedArray[objIndex].inspectionSheetCheckResultNotes = e.target.value;
            setState((st) => ({ ...st, VehicleDailyCheckResultsVM: changedArray }));
        },
        [state.VehicleDailyCheckResultsVM]
    );

    const changeResutNotesState = useCallback(
        (id, des) => (e) => {
            markActivity();
            let changedArray = [...state.VehicleDailyCheckResultsVM];
            let objIndex = state.VehicleDailyCheckResultsVM.findIndex((x) => x.inspectionSheetCheckID === id);
            changedArray[objIndex].inspectionSheetCheckResultEnteredText = e.target.value;
            setState((st) => ({ ...st, VehicleDailyCheckResultsVM: changedArray }));
        },
        [state.VehicleDailyCheckResultsVM]
    );

    const changeAllChildChecks = (buttonId, condition, groupLabel) => () => {
        markActivity();
        const grp = state.checksList.find((l) => l.inspectionSheetSectionDescription === groupLabel);
        if (grp.state === true) {
            grp.state = false;
        } else {
            grp.state = condition;
        }
        if (grp) {
            const sheetsCheckIds = grp.inspectionSheetChecksVM.map((p) => p.inspectionSheetCheckID);
            setState((st) => {
                const newSt = { ...st };
                sheetsCheckIds.forEach((id) => {
                    const sheetsCheck = newSt.VehicleDailyCheckResultsVM.find((c) => c.inspectionSheetCheckID === id);
                    if (sheetsCheck) {
                        sheetsCheck.inspectionSheetCheckResultOptionCode = grp.state ? buttonId : null;
                        newSt[id] = grp.state ? buttonId : null;
                    }
                });
                return { ...newSt, VehicleDailyCheckResultsVM: [...newSt.VehicleDailyCheckResultsVM] };
            });
        }
    };

    //Handle Inspection tyress --> Copy Data

    const handleInspection = () => {
        markActivity();
        const mergeAxles = (axles) => {
            return axles.reduce((acc, curr) => {
                const existingAxleIndex = acc.findIndex((item) => item.axleNumber === curr.axleNumber);
                if (existingAxleIndex !== -1) {
                    // Merge properties without overriding
                    acc[existingAxleIndex] = { ...acc[existingAxleIndex], ...curr };
                } else {
                    // Add new axle
                    acc.push(curr);
                }
                return acc;
            }, []);
        };

        let value = state.inspectionSheetAxlesVM[0]?.osTyreMaker || 'AS';
        let depth = state.inspectionSheetAxlesVM[0]?.osTreadDepth || null;
        let pressure = state.inspectionSheetAxlesVM[0]?.osTyrePressure || null;
        let breaks = state.inspectionSheetAxlesVM[0]?.osBrakeLineRemaining || null;
        const isFourAxles = Number(state.vehicleNoOfAxles) === 4;

        let axle = [
            {
                axleNumber: 1,
                osTyreMaker: value,
                nsTyreMaker: value,
                nsTreadDepth: depth,
                osTreadDepth: depth,
                nsTyrePressure: pressure,
                nsBrakeLineRemaining: breaks,
                osTyrePressure: pressure,
                osBrakeLineRemaining: breaks
            },
            isFourAxles
                ? {
                      axleNumber: 2,
                      osTyreMaker: value,
                      nsTyreMaker: value,
                      nsTreadDepth: depth,
                      osTreadDepth: depth,
                      nsTyrePressure: pressure,
                      nsBrakeLineRemaining: breaks,
                      osTyrePressure: pressure,
                      osBrakeLineRemaining: breaks
                  }
                : {
                      axleNumber: 2,
                      osTyreMaker: value,
                      osFrontTyreMaker: value,
                      nsFrontTyreMaker: value,
                      nsTyreMaker: value,
                      nsFrontTreadDepth: depth,
                      nsTreadDepth: depth,
                      osFrontTreadDepth: depth,
                      osTreadDepth: depth,
                      nsFrontTyrePressure: pressure,
                      nsTyrePressure: pressure,
                      nsBrakeLineRemaining: breaks,
                      osFrontTyrePressure: pressure,
                      osTyrePressure: pressure,
                      osBrakeLineRemaining: breaks
                  }
        ];
        if (Number(state.vehicleNoOfAxles) === 3) {
            axle.push({
                axleNumber: 3,
                osTyreMaker: value,
                osFrontTyreMaker: value,
                nsFrontTyreMaker: value,
                nsTyreMaker: value,
                nsFrontTreadDepth: depth,
                nsTreadDepth: depth,
                osFrontTreadDepth: depth,
                osTreadDepth: depth,
                nsFrontTyrePressure: pressure,
                nsTyrePressure: pressure,
                nsBrakeLineRemaining: breaks,
                osFrontTyrePressure: pressure,
                osTyrePressure: pressure,
                osBrakeLineRemaining: breaks
            });
        }

        if (Number(state.vehicleNoOfAxles) === 4) {
            axle.push(
                {
                    axleNumber: 3,
                    osTyreMaker: value,
                    osFrontTyreMaker: value,
                    nsFrontTyreMaker: value,
                    nsTyreMaker: value,
                    nsFrontTreadDepth: depth,
                    nsTreadDepth: depth,
                    osFrontTreadDepth: depth,
                    osTreadDepth: depth,
                    nsFrontTyrePressure: pressure,
                    nsTyrePressure: pressure,
                    nsBrakeLineRemaining: breaks,
                    osFrontTyrePressure: pressure,
                    osTyrePressure: pressure,
                    osBrakeLineRemaining: breaks
                },
                {
                    axleNumber: 4,
                    osTyreMaker: value,
                    osFrontTyreMaker: value,
                    nsFrontTyreMaker: value,
                    nsTyreMaker: value,
                    nsFrontTreadDepth: depth,
                    nsTreadDepth: depth,
                    osFrontTreadDepth: depth,
                    osTreadDepth: depth,
                    nsFrontTyrePressure: pressure,
                    nsTyrePressure: pressure,
                    nsBrakeLineRemaining: breaks,
                    osFrontTyrePressure: pressure,
                    osTyrePressure: pressure,
                    osBrakeLineRemaining: breaks
                }
            );
        }
        setState((st) => {
            return {
                ...st,
                inspectionSheetAxlesVM: mergeAxles([...st.inspectionSheetAxlesVM, ...axle])
            };
        });
    };

    const handleInputs = (axelNo) => (e) => {
        markActivity();
        let showError = {};
        const { name, value } = e.target;
        let showTost = false;
        setState((st) => {
            let ax = st.inspectionSheetAxlesVM.find((a) => a.axleNumber === axelNo);
            if (!ax) {
                ax = { axleNumber: axelNo };
                st.inspectionSheetAxlesVM.push(ax);
            }
            ax[name] = value;
            switch (name) {
                case 'osTreadDepth':
                    showError.message = (value > 0 && value > 20) || value < 0 ? `Axle ${axelNo} ${name}  must be Smaller than 20 and greater than 0` : null;
                    showTost = true;
                    break;
                case 'osFrontTreadDepth':
                    showError.message = (value > 0 && value > 20) || value < 0 ? `Axle ${axelNo} ${name}  must be Smaller than 20 and greater than 0` : null;
                    showTost = true;
                    break;
                case 'nsTreadDepth':
                    showError.message = (value > 0 && value > 20) || value < 0 ? `Axle ${axelNo} ${name}  must be Smaller than 20 and greater than 0` : null;
                    showTost = true;
                    break;
                case 'nsFrontTreadDepth':
                    showError.message = (value > 0 && value > 20) || value < 0 ? `Axle ${axelNo} ${name}  must be Smaller than 20 and greater than 0` : null;
                    showTost = true;
                    break;
                case 'osTyrePressure':
                    showError.message = (value > 0 && value > 130) || value < 0 ? `Axle ${axelNo} ${name}  must be Smaller than 130 and greater than 0` : null;
                    showTost = true;
                    break;
                case 'osFrontTyrePressure':
                    showError.message = (value > 0 && value > 130) || value < 0 ? `Axle ${axelNo} ${name}  must be Smaller than 130 and greater than 0` : null;
                    showTost = true;
                    break;
                case 'nsTyrePressure':
                    showError.message = (value > 0 && value > 130) || value < 0 ? `Axle ${axelNo} ${name}  must be Smaller than 130 and greater than 0` : null;
                    showTost = true;
                    break;
                case 'nsFrontTyrePressure':
                    showError.message = (value > 0 && value > 130) || value < 0 ? `Axle ${axelNo} ${name}  must be Smaller than 130 and greater than 0` : null;
                    showTost = true;
                    break;
                case 'nsBrakeLineRemaining':
                    showError.message = (value > 0 && value > 100) || value < 0 ? `Axle ${axelNo} ${name}  must be Smaller than 100 and greater than 0` : null;
                    showTost = true;
                    break;
                case 'osBrakeLineRemaining':
                    showError.message = (value > 0 && value > 100) || value < 0 ? `Axle ${axelNo} ${name}  must be Smaller than 100 and greater than 0` : null;
                    showTost = true;
                    break;

                default:
                    showError.message = null;
                    showTost = false;
                    break;
            }

            return { ...st, inspectionSheetAxlesVM: [...st.inspectionSheetAxlesVM], axleErrors: showError, showTost: showTost };
        });
    };

    //Submit Data...........

    const validations = () => {
        let formIsValid = true;
        let errors = {};
        let errorMessage = '';

        // let checkIsLegalReqFields = state.VehicleDailyCheckResultsVM.filter((x) => {
        //     return x.inspectionSheetCheckLegalRequirement === true && x.inspectionSheetCheckResultOptionCode == null && !x.inspectionSheetCheckFreeTextField;
        // });
        // let checkIsLegalReqText = state.VehicleDailyCheckResultsVM.filter((x) => {
        //     return x.inspectionSheetCheckLegalRequirement === true && !x.inspectionSheetCheckResultEnteredText && x.inspectionSheetCheckFreeTextField;
        // });

        const checkIsLegalReqFields = state.VehicleDailyCheckResultsVM.filter(
            (x) => x.inspectionSheetCheckLegalRequirement === true && x.inspectionSheetCheckFieldTypeID === 'CO' && !x.inspectionSheetCheckResultOptionCode
        );

        const checkIsLegalReqText = state.VehicleDailyCheckResultsVM.filter(
            (x) => x.inspectionSheetCheckLegalRequirement === true && x.inspectionSheetCheckFieldTypeID !== 'CO' && !x.inspectionSheetCheckResultEnteredText
        );
        let checkIsPhotoMandatory = state.VehicleDailyCheckResultsVM.filter((x) => {
            return x.inspectionSheetCheckPhotoMandatory === true && !(x.photosUploaded > 0 || x.startPhotosUploaded > 0 || x.basicCount > 0);
        });

        let checksNotes = state.VehicleDailyCheckResultsVM.filter((x) => {
            const hasOptionD = x.inspectionSheetCheckResultOptionCode === 'D';
            const isListFailed =
                x.inspectionSheetCheckFieldTypeID === 'LT' &&
                state.listOptionsVM.some(
                    (k) =>
                        k.inspectionSheetListId === x.inspectionSheetCheckListTypeID &&
                        k.name === x.inspectionSheetCheckResultEnteredText &&
                        (k.setFailed === true || String(k.setFailed).toLowerCase() === 'true')
                );
            return (hasOptionD || isListFailed) && (x.inspectionSheetCheckResultNotes == null || x.inspectionSheetCheckResultNotes === '');
        });
        let axel1Validation = state.inspectionSheetAxlesVM.find((a) => a.axleNumber === 1);
        let axel2Validation = state.inspectionSheetAxlesVM.find((a) => a.axleNumber === 2);
        let axel3Validation = state.inspectionSheetAxlesVM.find((a) => a.axleNumber === 3);
        let axel4Validation = state.inspectionSheetAxlesVM.find((a) => a.axleNumber === 4);

        const singleAxleFields = [
            'osTreadDepth',
            'nsTreadDepth',
            'osBrakeLineRemaining',
            'nsBrakeLineRemaining',
            'osTyrePressure',
            'osTyreMaker',
            'nsTyrePressure',
            'nsTyreMaker'
        ];

        let isAxel1Valid =
            axel1Validation &&
            singleAxleFields.every(
                (field) => axel1Validation[field] !== undefined && axel1Validation[field] !== null && axel1Validation[field] !== ''
            );

        let isAxel2Valid = false;
        if (axel2Validation) {
            if (Number(state.vehicleNoOfAxles) === 4) {
                isAxel2Valid = singleAxleFields.every(
                    (field) => axel2Validation[field] !== undefined && axel2Validation[field] !== null && axel2Validation[field] !== ''
                );
            } else {
                isAxel2Valid = Object.values(axel2Validation).every((value) => value !== '');
            }
        }

        let isAxel3Valid = axel3Validation && Object.values(axel3Validation).every((value) => value !== '');
        let isAxel4Valid = axel4Validation && Object.values(axel4Validation).every((value) => value !== '');

        // console.log(checksNotes, 'checksNotes');

        let AxelOne = 1;
        let AxelTwo = 1;
        let AxelThreeVal = 1;
        let AxelFourVal = 1;

        if (isAxel1Valid) {
            AxelOne = Object.keys(axel1Validation).length || 1;
        }
        if (isAxel2Valid) {
            AxelTwo = Object.keys(axel2Validation).length || 1;
        }
        if (isAxel3Valid) {
            AxelThreeVal = Object.keys(axel3Validation).length || 1;
        }
        if (isAxel4Valid) {
            AxelFourVal = Object.keys(axel4Validation).length || 1;
        }
        if (flags.displayMileage) {
            if (!state.vehicleDailyCheckMileage) {
                errors.vehicleDailyCheckMileage = `Odometer Reading  is required`;
                errorMessage = errorMessage.concat(errors.vehicleDailyCheckMileage) + '\n';
                formIsValid = false;
            }
        }

        // if (checksOption.length > 0) {
        //     errors.message = 'This field is required';
        //     formIsValid = false;
        // }
        if (flags.displayTyres) {
            if (state.vehicleNoOfAxles) {
                const noOfAxles = Number(state.vehicleNoOfAxles);
                if (noOfAxles === 1) {
                    if (AxelOne < 8) {
                        errors.axelone = 'Axel 1 fields are required';
                        errorMessage = errorMessage.concat(errors.axelone) + '\n';
                        formIsValid = false;
                    }
                }
                if (noOfAxles === 2) {
                    if (AxelOne < 8) {
                        errors.axelone = 'Axel 1 fields are required';
                        errorMessage = errorMessage.concat(errors.axelone) + '\n';
                        formIsValid = false;
                    }

                    if (AxelTwo < 14) {
                        errors.axeltwo = 'Axel 2 fields are required';
                        errorMessage = errorMessage.concat(errors.axeltwo) + '\n';
                        formIsValid = false;
                    }
                }
                if (noOfAxles === 3) {
                    if (AxelOne < 8) {
                        errors.axelone = 'Axel 1 fields are required';
                        errorMessage = errorMessage.concat(errors.axelone) + '\n';
                        formIsValid = false;
                    }

                    if (AxelTwo < 14) {
                        errors.axeltwo = 'Axel 2 fields are required';
                        errorMessage = errorMessage.concat(errors.axeltwo) + '\n';
                        formIsValid = false;
                    }
                    if (AxelThreeVal < 14) {
                        errors.axelthree = 'Axel 3 fields are required';
                        errorMessage = errorMessage.concat(errors.axelthree) + '\n';
                        formIsValid = false;
                    }
                }
                if (noOfAxles === 4) {
                    if (AxelOne < 8) {
                        errors.axelone = 'Axel 1 fields are required';
                        errorMessage = errorMessage.concat(errors.axelone) + '\n';
                        formIsValid = false;
                    }

                    if (AxelTwo < 8) {
                        errors.axeltwo = 'Axel 2 fields are required';
                        errorMessage = errorMessage.concat(errors.axeltwo) + '\n';
                        formIsValid = false;
                    }
                    if (AxelThreeVal < 14) {
                        errors.axelthree = 'Axel 3 fields are required';
                        errorMessage = errorMessage.concat(errors.axelthree) + '\n';
                        formIsValid = false;
                    }
                    if (AxelFourVal < 14) {
                        errors.axelfour = 'Axel 4 fields are required';
                        errorMessage = errorMessage.concat(errors.axelfour) + '\n';
                        formIsValid = false;
                    }
                }
            } else {
                if (AxelOne < 8) {
                    errors.axelone = 'Axel 1 fields are required';
                    errorMessage = errorMessage.concat(errors.axelone) + '\n';
                    formIsValid = false;
                }

                if (AxelTwo <= 14) {
                    errors.axeltwo = 'Axel 2 fields are required';
                    errorMessage = errorMessage.concat(errors.axeltwo) + '\n';
                    formIsValid = false;
                }
            }
        }

        if (checksNotes.length > 0) {
            errors.note = 'Note is required';
            let notesError = checksNotes.map((x) => `Defect Note of (${x.inspectionSheetCheckDescription}) is required`).join('\n');

            errorMessage = errorMessage.concat(notesError) + '\n';
            formIsValid = false;
        }

        if (!state.techniciansign) {
            errors.techniciansign = 'Signature is required';
            errorMessage = errorMessage.concat(errors.techniciansign) + '\n';
            formIsValid = false;
        }

        if (checkIsLegalReqFields.length > 0) {
            errors.legalReq = `Please complete ${checkIsLegalReqFields.length} mandatory legal requirement checks.`;
            errorMessage = errorMessage.concat(errors.legalReq) + '\n';
            formIsValid = false;
        }
        if (checkIsLegalReqText.length > 0) {
            errors.legalReq = `Please complete ${checkIsLegalReqText.length} mandatory legal requirement checks Result.`;
            errorMessage = errorMessage.concat(errors.legalReq) + '\n';
            formIsValid = false;
        }

        if (checkIsPhotoMandatory.length > 0) {
            let photoReqNames = checkIsPhotoMandatory.map((x) => `- ${x.inspectionSheetCheckDescription}`).join('\n');
            errors.photoReq = `Please upload a photo for the following mandatory photo checks:\n${photoReqNames}`;
            errorMessage = errorMessage.concat(errors.photoReq) + '\n';
            formIsValid = false;
        }
        // if (!state.vehicleInspectionInspectionComment) {
        //     errors.vehicleInspectionInspectionComment = 'Vehicle checker Comment is required';
        //     formIsValid = false;
        // }
        if (state.date && moment(state.date).isAfter(moment(), 'day')) {
            errors.date = 'Date of check cannot be a future date';
            errorMessage = errorMessage.concat(errors.date) + '\n';
            formIsValid = false;
        }
        setState((st) => ({
            ...st,
            errors: errors
        }));
        // return true;
        if (errorMessage) {
            alert(errorMessage);
        }
        return formIsValid;
    };

    const handleConfirmPopup = () => {
        if (validations()) {
            setBtnLoader(true);
            setState((st) => ({
                ...st,
                showConfirmMessage: !st.showConfirmMessage
            }));
            setBtnLoader(false);
        }
    };

    const submitData = async (status, isAutoSave = false) => {
        if (isAutoSave && inFlightSaveRef.current) {
            // Never run two saves at once (on the first save both would send a null id and create
            // duplicates, and out-of-order responses could overwrite newer data). Run it right after
            // the current save finishes instead — see the finally block below.
            pendingSaveRef.current = true;
            return;
        }
        if (!isAutoSave && inFlightSaveRef.current) {
            // Manual Save/Submit: let a running auto-save finish first so we reuse its inspection id.
            await inFlightSaveRef.current;
        }

        let resultVM = state.VehicleDailyCheckResultsVM.map((e) => ({
            inspectionSheetCheckResultCheckID: e.inspectionSheetCheckResultCheckID,
            inspectionSheetCheckResultOptionCode: e.inspectionSheetCheckResultOptionCode,
            inspectionSheetCheckResultNotes: e.inspectionSheetCheckResultNotes,
            inspectionSheetCheckResultIMReference: e.inspectionSheetCheckResultIMReference,
            inspectionSheetCheckResultDefectID: e.inspectionSheetCheckResultDefectID,
            inspectionSheetCheckResultEnteredText: e.inspectionSheetCheckResultEnteredText
        }));

        let data = {
            vehicleInspectionScheduleID: state.vehicleInspectionScheduleID,
            vehicleInspectionStatusID: status,
            vehicleInspectionDateInspected: state.date,
            vehicleInspectionResult: state.vehicleInspectionResult,
            vehicleInspectionMileage: state.vehicleDailyCheckMileage,
            vehicleInspectionInspectorName: state.vehicleDailyCheckCheckerName,
            vehicleInspectionInspectorSignature: state.techniciansign,
            vehicleInspectionInspectionComment: state.vehicleInspectionInspectionComment,
            // vehicleInspectionSignedOffName: state.vehicleInspectionSignedOffName,
            // vehicleInspectionSignedOffSignature: state.vehicleInspectionSignedOffSignature,
            // vehicleInspectionSignedOffDate: state.vehicleInspectionSignedOffDate,
            // vehicleInspectionSignedOffIPAddress: state.vehicleInspectionSignedOffIPAddress,
            vehicleInspectionBrakeTestTypeID: state.vehicleInspectionBrakeTestTypeID,
            vehicleInspectionBrakeTestNumber: state.vehicleInspectionBrakeTestNumber,
            vehicleInspectionRoadCondition: state.vehicleInspectionRoadCondition,
            vehicleInspectionServiceBrakePerformance: state.vehicleInspectionServiceBrakePerformance,
            vehicleInspectionSecondaryBrakePerformance: state.vehicleInspectionSecondaryBrakePerformance,
            vehicleInspectionParkingBrakePerformance: state.vehicleInspectionParkingBrakePerformance,
            vehicleInspectionID: state.vehicleInspectionID || savedInspectionIdRef.current,
            // vehicleInspectionSignedOffComment: state.vehicleInspectionSignedOffComment,
            AutoSaved: isAutoSave ? true : false,
            inspectionSheetCheckResultsVM: resultVM,
            inspectionSheetAxlesVM: state.inspectionSheetAxlesVM
                .filter((obj) => Object.keys(obj).length > 1)
                .map((ax) => {
                    if (Number(state.vehicleNoOfAxles) === 4 && ax.axleNumber === 2) {
                        const {
                            osFrontTreadDepth,
                            nsFrontTreadDepth,
                            osFrontTyrePressure,
                            osFrontTyreMaker,
                            nsFrontTyrePressure,
                            nsFrontTyreMaker,
                            ...rest
                        } = ax;
                        return rest;
                    }
                    return ax;
                }),
            inspectionSheetCheckPhotoVM: state.imageUpload
                .filter((data) => data.inspectionSheetCheckPhotos.length > 0)
                .map((data) => ({
                    ...data,
                    inspectionSheetCheckPhotos: data.inspectionSheetCheckPhotos.map(({ img }) => img)
                })),

            vehicleInspectionBrakeTestPhoto: state.vehicleInspectionBrakeTestPhoto || ''
        };

        // The payload above is a snapshot of every change made up to now, so this window is saved:
        // stop its countdown and clear the unsaved flag. Any change from here on (including while
        // the request is in flight) sets the flag again and starts the next countdown.
        if (autoSaveTimerRef.current) {
            clearTimeout(autoSaveTimerRef.current);
            autoSaveTimerRef.current = null;
        }
        activitySinceLastSaveRef.current = false;

        let finishInFlight = () => {};
        if (isAutoSave) {
            inFlightSaveRef.current = new Promise((resolve) => (finishInFlight = resolve));
        }

        try {
            if (!isAutoSave) setBtnLoader(true);
            let res = await postChecksData(data);
            if (res.success) {
                if (res?.data?.vehicleInspectionID) {
                    savedInspectionIdRef.current = res.data.vehicleInspectionID;
                }
                if (isAutoSave) {
                    if (res?.data?.vehicleInspectionID) {
                        setState((st) => ({
                            ...st,
                            vehicleInspectionID: res.data.vehicleInspectionID,
                            isAutoSave: true,
                            postimageUpload: st.imageUpload.map((data) => ({
                                ...data,
                                inspectionSheetCheckPhotos: data.inspectionSheetCheckPhotos.map((p) => ({ ...p, isAutoSaved: true }))
                            }))
                        }));
                    }
                    return;
                }
                showToastSuccess('Vehicle Checks added successfully');
                if (checkhaveAccess?.CanViewJobs && res?.data?.jobID) {
                    history.push({
                        pathname: `/controller/jobTabScreen/${res.data?.jobID}/${props.sheduleVechicleID}`,
                        state: 'jobs',
                        search: 'tab_testing_tabs=1'
                    });
                    props.onClose(true);
                } else {
                    props.onClose(true);
                }
                setBtnLoader(false);
            } else {
                if (!isAutoSave) {
                    showToastError(res.message);
                    setBtnLoader(false);
                } else {
                    // Auto-save rejected: these changes were not stored, so mark them unsaved again and
                    // start a new countdown to retry, instead of dropping them.
                    markActivity();
                }
            }
        } catch (error) {
            if (!isAutoSave) {
                setBtnLoader(false);
                showToastError(`An error occurred: ${error.message}`);
            } else {
                markActivity(); // network/server error: keep the changes and retry next window
            }
        } finally {
            if (isAutoSave) {
                inFlightSaveRef.current = null;
                finishInFlight();
                // The countdown expired while this save was running: save the newer changes now,
                // using the id this save just returned (savedInspectionIdRef).
                if (pendingSaveRef.current) {
                    pendingSaveRef.current = false;
                    if (activitySinceLastSaveRef.current && autoSaveRef.current) {
                        autoSaveRef.current();
                    }
                }
            }
        }
    };

    autoSaveRef.current = () => {
        if (state.hideSignOff || state.isDisabled) return;
        if (!(state.checksList && state.checksList.length > 0)) return;
        submitData(0, true);
    };

    useEffect(() => {
        const handleFieldInteraction = (e) => {
            const target = e.target;
            if (!target || !target.closest) return;
            // Ignore signature-related interactions
            if (target.closest('canvas, .sigPad, .sigContainer, [title="Clear Signature"], [title="Use default signature"]')) {
                return;
            }
            // Ignore camera icon and photo modal interactions (opening/closing modal should not trigger auto-save)
            if (
                target.closest('.uploadWithBadgeButton, .uploadWithBadgeButtonRequired, .dialog-container, input[type="file"]') ||
                target.closest('button')?.querySelector('.doneIcon') ||
                target.closest('.MuiBadge-root')?.querySelector('.uploadWithBadgeButton, .uploadWithBadgeButtonRequired')
            ) {
                return;
            }
            if (
                target.closest(
                    'input, textarea, select, button, [role="button"], [role="option"], [role="menuitem"], [role="listbox"], .MuiSelect-root, .MuiButtonBase-root'
                )
            ) {
                markActivity();
            }
        };

        // Typing/changing a field counts as activity, except file pickers (image
        // selection is handled by the image handlers — only Submit counts in the preview
        // modal) and anything inside the signature pad.
        const handleFieldChange = (e) => {
            const target = e.target;
            if (target && target.type === 'file') return;
            if (target && target.closest && target.closest('canvas, .sigPad, .sigContainer')) return;
            markActivity();
        };

        window.addEventListener('input', handleFieldChange, true);
        window.addEventListener('change', handleFieldChange, true);
        window.addEventListener('click', handleFieldInteraction, true);

        return () => {
            window.removeEventListener('input', handleFieldChange, true);
            window.removeEventListener('change', handleFieldChange, true);
            window.removeEventListener('click', handleFieldInteraction, true);
            if (autoSaveTimerRef.current) {
                clearTimeout(autoSaveTimerRef.current);
            }
        };
    }, []);

    //Image Handler
    //     if (hideImg && hideDefect) {
    //         colSpan = 3;
    //     } else if (hideDefect || hideImg) {
    //         colSpan = hideDefect ? 1 : 2;
    //     } else {
    //         colSpan = 1;
    //     }

    //     return colSpan;
    // };

    //Image Handler
    const imageHandler = async (ResultID = null, inspectioncheckID, count = 0, isDiabled) => {
        if (props.checkID) {
            try {
                let res = await getImageByID(ResultID);
                let imageList = [...res?.data?.list];
                if (res?.data?.list.length > 0) {
                    setState((st) => ({
                        ...st,
                        showImageModal: false,
                        showImageModalAPI: true,
                        inspectioncheckID: inspectioncheckID,
                        inspectionCheckResultID: ResultID,
                        selectedImages: imageList.map((m) => m.vehicleInspectionsPhotoObject) || [],
                        getImageList: imageList || [],
                        postImagesList: [],
                        showSubmit: false,
                        fromAPI: ResultID ? true : false,
                        isModalReadonly: isDiabled ? isDiabled : false
                    }));
                } else {
                    let changedArray = [...state.VehicleDailyCheckResultsVM];
                    let objIndex = state.VehicleDailyCheckResultsVM.findIndex((x) => x.inspectionSheetCheckID === inspectioncheckID);
                    const localImages = changedArray[objIndex]?.images || [];
                    if (localImages.length > 0) {
                        setState((st) => ({
                            ...st,
                            showImageModal: true,
                            showImageModalAPI: false,
                            inspectioncheckID: inspectioncheckID,
                            selectedImages: localImages,
                            isModalReadonly: isDiabled ? isDiabled : false,
                            fromAPI: false
                        }));
                    } else {
                        setState((st) => ({
                            ...st,
                            showImageModal: false,
                            showImageModalAPI: false,
                            inspectioncheckID: inspectioncheckID,
                            selectedImages: [],
                            isModalReadonly: isDiabled ? isDiabled : false,
                            fromAPI: false
                        }));
                        setTimeout(() => {
                            if (localFileInputRef.current) {
                                localFileInputRef.current.click();
                            }
                        }, 50);
                    }
                }
            } catch (error) {
                showToastError('Error fetching images');
            }
        } else {
            let changedArray = [...state.VehicleDailyCheckResultsVM];
            let objIndex = state.VehicleDailyCheckResultsVM.findIndex((x) => x.inspectionSheetCheckID === inspectioncheckID);
            const localImages = changedArray[objIndex]?.images || [];
            if (localImages.length > 0 || state.isAutoSave) {
                setState((st) => ({
                    ...st,
                    showImageModal: true,
                    showImageModalAPI: false,
                    inspectioncheckID: inspectioncheckID,
                    selectedImages: localImages,
                    isModalReadonly: isDiabled ? isDiabled : false,
                    fromAPI: false
                }));
            } else {
                setState((st) => ({
                    ...st,
                    showImageModal: false,
                    showImageModalAPI: false,
                    inspectioncheckID: inspectioncheckID,
                    selectedImages: [],
                    isModalReadonly: isDiabled ? isDiabled : false,
                    fromAPI: false
                }));
                setTimeout(() => {
                    if (localFileInputRef.current) {
                        localFileInputRef.current.click();
                    }
                }, 50);
            }
        }
    };

    const sumbitImage = () => {
        // Submitting the image preview is what counts as activity; the auto-save timer
        // then picks it up on its next tick.
        markActivity();
        setImgLoader(true);
        if (state.selectedImages?.length > 0) {
            showToastSuccess('Images Uploaded successfully');
            let changedArray = [...state.VehicleDailyCheckResultsVM];
            let objIndex = state.VehicleDailyCheckResultsVM.findIndex((x) => x.inspectionSheetCheckID === state.inspectioncheckID);
            changedArray[objIndex].basicCount = changedArray[objIndex]?.images.length; // changedArray[objIndex].inspectionSheetCheckResultNotes = e.target.value;
            setState((st) => ({ ...st, VehicleDailyCheckResultsVM: changedArray, showImageModal: false, showSubmit: false }));
        } else {
            setState((st) => ({ ...st, showImageModal: false, showSubmit: false }));
        }
        setImgLoader(false);
    };

    const sumbitImageApi = async () => {
        markActivity();
        setImgLoader(true);
        let tempArray = [...(state.postImagesList || [])];
        let data = {
            vehicleInspectionsPhotoID: null,
            vehicleInspectionsPhotoResultID: state.inspectionCheckResultID,
            vehicleInspectionsPhotoObject: tempArray
        };
        let res = await PostImage(data);
        if (res.success) {
            let changedArray = [...state.VehicleDailyCheckResultsVM];
            let objIndex = state.VehicleDailyCheckResultsVM.findIndex(
                (x) =>
                    (state.inspectionCheckResultID && x.inspectionSheetCheckResultID === state.inspectionCheckResultID) ||
                    (state.inspectioncheckID && x.inspectionSheetCheckID === state.inspectioncheckID)
            );
            if (objIndex > -1) {
                changedArray[objIndex].basicCount = state.selectedImages.length;
                changedArray[objIndex].photosUploaded = state.selectedImages.length;
            }
            showToastSuccess('image Uploaded successfully');

            setState((st) => ({
                ...st,
                showImageModal: false,
                showImageModalAPI: false,
                VehicleDailyCheckResultsVM: changedArray,
                postImagesList: [],
                showSubmit: false
            }));
        }
        setImgLoader(false);
    };

    const onImageChangeAPI = (imageList) => {
        // Selecting images in the preview modal doesn't count as activity — only
        // clicking Submit (sumbitImageApi) does.
        setImgLoader(true);
        let changedArray = [...state.VehicleDailyCheckResultsVM];
        let FilterimagesList = imageList.map((m) => (m.data_url ? m.data_url : m));
        let objIndex = state.VehicleDailyCheckResultsVM.findIndex(
            (x) =>
                (state.inspectionCheckResultID && x.inspectionSheetCheckResultID === state.inspectionCheckResultID) ||
                (state.inspectioncheckID && x.inspectionSheetCheckID === state.inspectioncheckID)
        );

        if (objIndex > -1) {
            changedArray[objIndex].images = FilterimagesList;
            changedArray[objIndex].basicCount = FilterimagesList.length;
            changedArray[objIndex].photosUploaded = FilterimagesList.length;
        }

        const dbCount = state.getImageList ? state.getImageList.length : 0;
        const newImagesToUpload = FilterimagesList.slice(dbCount);

        setState((st) => ({
            ...st,
            VehicleDailyCheckResultsVM: changedArray,
            selectedImages: FilterimagesList,
            postImagesList: newImagesToUpload,
            showSubmit: newImagesToUpload.length > 0,
            showImageModalAPI: st.showImageModalAPI
        }));
        setImgLoader(false);
    };

    const onImageChange = (imageList) => {
        setImgLoader(true);
        let changedArray = [...state.VehicleDailyCheckResultsVM];
        let FilterimagesList;
        let finalArray = [];

        // Find index based on inspectionSheetCheckID
        let objIndex = state.VehicleDailyCheckResultsVM.findIndex((x) => x.inspectionSheetCheckID === state.inspectioncheckID);
        if (objIndex !== -1) {
            FilterimagesList = imageList.map((m) => (m.data_url ? m.data_url : m));
            changedArray[objIndex].images = FilterimagesList;
            changedArray[objIndex].basicCount = FilterimagesList.length;
        }

        let tempArray = [...state.imageUpload];
        let tempArrayObjIndex = tempArray.findIndex((x) => x.inspectionSheetCheckCheckID === state.inspectioncheckID);

        if (tempArrayObjIndex !== -1) {
            tempArray[tempArrayObjIndex].inspectionSheetCheckPhotos = [...FilterimagesList].map((m) => ({ img: m.data_url ? m.data_url : m }));
        } else {
            tempArray.push({
                inspectionSheetCheckCheckID: state.inspectioncheckID,
                inspectionSheetCheckPhotos: FilterimagesList.map((m) => ({ img: m.data_url ? m.data_url : m }))
            });
        }

        if (state.postimageUpload && state.postimageUpload.length > 0) {
            finalArray = tempArray.map((check) => {
                let savedCheck = [...state.postimageUpload].find((item) => item.inspectionSheetCheckCheckID === check.inspectionSheetCheckCheckID);
                if (!savedCheck) {
                    return check;
                }
                return {
                    ...check,
                    inspectionSheetCheckPhotos: check.inspectionSheetCheckPhotos.filter((photo) => {
                        let savedPhoto = savedCheck.inspectionSheetCheckPhotos?.find((item) => item.img === photo.img);
                        return !savedPhoto?.isAutoSaved;
                    })
                };
            });
        }

        const wasModalOpen = state.showImageModal;
        setState((st) => ({
            ...st,
            VehicleDailyCheckResultsVM: changedArray,
            selectedImages: FilterimagesList,
            imageUpload: finalArray.length > 0 ? finalArray : tempArray,
            showSubmit: true,
            showImageModal: st.showImageModal
        }));
        setImgLoader(false);
        // First-time flow: the file picker opened directly (no preview modal, no Submit
        // button), so picking the file is the commit — count it as activity. Picks made
        // inside the preview modal wait for Submit (sumbitImage) instead.
        if (!wasModalOpen) {
            markActivity();
        }
    };

    const RemoveImage = async (val, i) => {
        // Removing an image happens inside the preview modal — only Submit counts.
        setImgLoader(true);
        const tempList = [...(state.getImageList || [])];
        let changedArray = [...state.VehicleDailyCheckResultsVM];
        let FilterimagesList = [...(state.selectedImages || [])];

        const targetPhoto = tempList[i];
        const photoIdToDelete = targetPhoto?.vehicleInspectionPhotoID || (typeof val === 'object' && val?.vehicleInspectionPhotoID);

        if (photoIdToDelete) {
            let res = await deleteImageByID(photoIdToDelete);
            if (res.success) {
                tempList.splice(i, 1);
                FilterimagesList.splice(i, 1);

                let objIndex = state.VehicleDailyCheckResultsVM.findIndex(
                    (x) =>
                        (state.inspectioncheckID && x.inspectionSheetCheckID === state.inspectioncheckID) ||
                        (state.inspectionCheckResultID && x.inspectionSheetCheckResultID === state.inspectionCheckResultID)
                );
                if (objIndex !== -1) {
                    changedArray[objIndex].images = FilterimagesList;
                    changedArray[objIndex].basicCount = FilterimagesList.length;
                    changedArray[objIndex].photosUploaded = FilterimagesList.length;
                }

                const updatedPostImagesList = FilterimagesList.slice(tempList.length);

                setState((st) => ({
                    ...st,
                    VehicleDailyCheckResultsVM: changedArray,
                    selectedImages: FilterimagesList,
                    getImageList: tempList,
                    postImagesList: updatedPostImagesList,
                    showSubmit: updatedPostImagesList.length > 0
                }));
                showToastSuccess('Image Removed Successfully');
            } else {
                showToastError(res?.message || 'Failed to remove image');
            }
        } else {
            FilterimagesList.splice(i, 1);
            if (tempList[i]) {
                tempList.splice(i, 1);
            }

            let objIndex = state.VehicleDailyCheckResultsVM.findIndex(
                (x) =>
                    (state.inspectioncheckID && x.inspectionSheetCheckID === state.inspectioncheckID) ||
                    (state.inspectionCheckResultID && x.inspectionSheetCheckResultID === state.inspectionCheckResultID)
            );
            if (objIndex > -1) {
                changedArray[objIndex].images = FilterimagesList;
                changedArray[objIndex].basicCount = FilterimagesList.length;
                changedArray[objIndex].photosUploaded = FilterimagesList.length;
            }

            const updatedPostImagesList = FilterimagesList.slice(tempList.length);

            setState((st) => ({
                ...st,
                VehicleDailyCheckResultsVM: changedArray,
                selectedImages: FilterimagesList,
                getImageList: tempList,
                postImagesList: updatedPostImagesList,
                showSubmit: updatedPostImagesList.length > 0
            }));
            showToastSuccess('Image Removed Successfully');
        }
        setImgLoader(false);
    };

    return (
        <InspectionCheCkContaxt.Provider
            value={{
                btnLoader,
                state,
                flags,
                widths,
                handleInput,
                signCanvas,
                clear,
                GetTechnicianSign,
                imageHandler,
                onImageChange,
                changeState,
                changeNotesState,
                changeResutNotesState,
                changeAllChildChecks,
                handleInputs,
                useDefaultSig,
                handleConfirmPopup,
                submitData,
                sumbitImage,
                setState,
                handleInspection,
                handleInpectionRow,
                closeInspection,
                portalSettings,
                getPreviousTyreData,
                RemoveImage,
                sumbitImageApi,
                onImageChangeAPI,
                imgLoader,
                closeActionTakenhandle,
                actionTakenHandle,
                isModal,
                localFileInputRef,
                apiFileInputRef,
                markActivity
            }}
        >
            {props.children}
        </InspectionCheCkContaxt.Provider>
    );
};
